import { Context, CustomQuery } from '@vue-storefront/core';
type LoginResponse = {
  token: string;
}

export default async function customLogin({ client, config }: Context, parms: CustomQuery): Promise<LoginResponse> {
  const { username, password, phone, phone_country_code } = parms;

  // console.log('[0]-------api开始登录--------', username, password);
  const url = new URL('/mall/member/login', config.api.url);
  if (phone) {
    const { data } = await client.post(url.href, { phone: phone, password: password, phone_country_code });
    if (data && data.data && data.data.token) {
      config.auth.setToken(data.data.token);
    }
    return data;
  } else {
    const { data } = await client.post(url.href, { email: username, password: password });
    if (data && data.data && data.data.token) {
      config.auth.setToken(data.data.token);
    }
    return data;
  }
}
